import React from "react";
import JournalData from "./index";
import PropTypes from 'prop-types';

const JournalDataCollection = ({ data }) => {
  if(!Array.isArray(data) || (Array.isArray(data) && data.length < 1)){
    return null;
  }
  
  return (
    <>
      {data.map((item, i) => {
        return (
          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-4" key={i}>
            <JournalData
              description={item.description}
              image={item.image}
              title={item.title}
            />
          </div>
        );
      })}
    </>
  );
};

JournalDataCollection.prototypes = {
  data : PropTypes.arrayOf(
    PropTypes.shape({
      description : PropTypes.string,
      image : PropTypes.string.isRequired,
      title : PropTypes.node,
    })
  ).isRequired
}
export default JournalDataCollection;
